import { render, staticRenderFns } from "./index.vue?vue&type=template&id=079c0e86"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('079c0e86')) {
      api.createRecord('079c0e86', component.options)
    } else {
      api.reload('079c0e86', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=079c0e86", function () {
      api.rerender('079c0e86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hotel/guarantee/index.vue"
export default component.exports